const PORTAL_LABELS = {
	mastersportal: 'Master studies',
	bachelorsportal: 'Bachelor studies',
	distancelearningportal: 'Online studies',
	preparationcoursesportal: 'Preparation courses',
	shortcoursesportal: 'Short courses',
	phdportal: 'PhD studies'
};

export const PortalType = {
	/**
	 * Extract hostname from url
	 *
	 * @return {String}
	 */
	getCurrentPortal() {
		const hostname = document.location.hostname;
		const splitHostname = hostname.split('.');
		return splitHostname[splitHostname.length - 2];
	},

	/**
	 * Get the portal placeholder label (this differs from the short hand in some cases)
	 *
	 * @returns {string}
	 */
	getPortalLabel() {
		const portal = PortalType.getCurrentPortal();

		if (!portal) {
			return 'studies';
		}
		return PORTAL_LABELS[portal];
	}
};
